/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.checkSignupQueue'

export { $nsid }

/** Check accounts location in signup queue. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    activated: l.boolean(),
    placeInQueue: l.optional(l.integer()),
    estimatedTimeMs: l.optional(l.integer()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
